import { render, staticRenderFns } from "./coordinator_user.vue?vue&type=template&id=ed9ad92a"
import script from "./coordinator_user.vue?vue&type=script&lang=js"
export * from "./coordinator_user.vue?vue&type=script&lang=js"
import style0 from "./coordinator_user.vue?vue&type=style&index=0&id=ed9ad92a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports